module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-list-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 margin-top"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified"
  }, [_vm._l((_vm.columns), function(key) {
    return [_c('a', {
      staticClass: "btn",
      class: _vm.btnColor(key),
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('patient_list_detail.btn.' + key)) + " "), (_vm.sortOrders[key] > 0) ? [_c('i', {
      staticClass: "fa fa-arrow-up"
    })] : [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]], 2)]
  })], 2)])]), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderedPatients), function(patient, index) {
    return _c('div', {
      staticClass: "col-sm-3 margin-top"
    }, [_c('div', {
      staticClass: "box text-center"
    }, [(patient.attributes['avartar-path']) ? _c('p', {
      staticClass: "img-area"
    }, [_c('img', {
      attrs: {
        "src": patient.attributes['avartar-path'] + '?token=' + _vm.authToken
      }
    })]) : _c('p', {
      staticClass: "img-area"
    }, [_c('i', {
      staticClass: "profile fa fa-user"
    })]), _c('h4', [_vm._v(_vm._s(patient.attributes['patient-name']) + " " + _vm._s(_vm.$t('patient_list_detail.label.honorific')))]), _c('p', {
      staticClass: "profile"
    }, [_vm._v(_vm._s(_vm.$t('patient_list_detail.label.sex')) + _vm._s(patient.attributes['sex'])), _c('br'), _vm._v(_vm._s(_vm.$t('patient_list_detail.label.birthday')) + _vm._s(patient.attributes['birthday'])), _c('br'), _vm._v(_vm._s(_vm.$t('patient_list_detail.label.age')) + _vm._s(_vm.$t('age', {
      'age': patient.attributes['age']
    })))]), _c('p', [_c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#avatar_upload_modal"
      },
      on: {
        "click": function($event) {
          _vm.$parent.uploadStart(patient.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('patient_list_detail.btn.icon_upload')))])]), _c('p', [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.showMedicineList(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('patient_list_detail.btn.medicine_list')))])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d21dbc0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/patient-list-detail.pug
// module id = 366
// module chunks = 1